<template>
  <vue-final-modal
    name="pinnacle-map-modal"
    :value="isPinnacleMapShowing && isPinnacleSDKLoaded"
    :classes="['pinnacle-map-modal-container']"
    overlay-class="pinnacle-map-modal-overlay"
    content-class="pinnacle-map-modal-content bg-white border"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="false"
    :esc-to-close="false"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    :resize="false"
    :keep-changed-style="true"
  >
    <div class="pinnacle-map-modal-content--header d-flex align-items-center justify-content-between px-3">
      <div class="d-flex align-items-center">
      </div>
      <button type="button" aria-label="Close" class="close" id="id-modal-close-button" @click="closeModal">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="pinnacle-map-modal-content--body">
      <PinnacleMap
        v-if="isPinnacleMapShowing && isPinnacleSDKLoaded && center && zoom && geography && geography.length > 0"
        :zoom="zoom"
        :center="center"
        :geography="geography"
        :primaryRecipientId="primaryRecipientId"
      />
    </div>
  </vue-final-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { EventBus } from '../events/eventBus';
import { isEqual } from 'lodash-es';
import PinnacleMap from "@/components/PinnacleMap";

export default {
  name: "PinnacleMapModal",
  components: { PinnacleMap },
  data() {
    return {
      geography: [],
      center: null,
      zoom: null,
      primaryRecipientId: null,
      isReceivingNewData: false,
      latestData: null,
      isReplaying: false,
      receivingNewDataTimeOut: null,
    }
  },
  computed: {
    ...mapGetters("pinnacle", ["isPinnacleMapShowing", "isPinnacleSDKLoaded"]),
    ...mapGetters("user", ["currentUser"])
  },
  async created() {
    this.registerEvents();
  },
  methods: {
    zoomSize(pos) {
      if (pos.latlng_accuracy < 20)
        return 18;
      else if (pos.latlng_accuracy < 50)
        return 17;
      else if (pos.latlng_accuracy < 100)
        return 16;
      else if (pos.latlng_accuracy < 800)
        return 15;
      else if (pos.latlng_accuracy < 2000)
        return 14;
      else if (pos.latlng_accuracy < 5000)
        return 12;
      else if (pos.latlng_accuracy < 10000)
        return 10;
      else
        return 10;
    },
    closeModal() {
      this.$store.commit("pinnacle/setIsPinnacleMapShowing", false);
    },
    registerEvents() {
      EventBus.$on("openPinnacleMapModal", (props) => {
        if (!this.isPinnacleMapShowing) {
          this.$store.commit("pinnacle/setPinnacleSDKLoadedStatus", false);
          const { geography, recipientId } = props;
          this.primaryRecipientId = recipientId;
          this.geography = [...geography];
          const primaryRecipientPos = geography.filter(i => i.recipient_id == recipientId);

          if (primaryRecipientPos && primaryRecipientPos.length > 0) {
            this.center = {
              lat: primaryRecipientPos[0].lat,
              lng: primaryRecipientPos[0].lng
            };

            this.zoom = this.zoomSize(primaryRecipientPos[0]);
          }
          this.$store.commit("pinnacle/setIsPinnacleMapShowing", true);
          this.loadPinnacleSDK();
        }
      });
    },
    loadPinnacleSDK() {
      if (!this.isPinnacleSDKLoaded) {
        const currentUserId = this.currentUser.user_id;
        const sdkElementId = `pinnacle-sdk-user-${currentUserId}`;
        const findSdkElement = document.getElementById(sdkElementId);
        if (!findSdkElement) {
          const pinnacleSdkScriptElement = document.createElement('script')
          pinnacleSdkScriptElement.setAttribute('src', '/js/pinnaclesdk/index.js');
          pinnacleSdkScriptElement.setAttribute('id', sdkElementId);
          document.head.appendChild(pinnacleSdkScriptElement);
          pinnacleSdkScriptElement.addEventListener("load", () => {
            this.$store.commit("pinnacle/setPinnacleSDKLoadedStatus", true);
          })
        }
      }
    }
  },
  beforeDestroy() {
    this.closeModal();
    EventBus.$off("openPinnacleMapModal");
    EventBus.$off("alertForNewGeoInformation");
  }
};
</script>

<style lang="scss">
.pinnacle-map-modal-container {
  display: flex;
  justify-content: center;
  align-items: center;

  .pinnacle-map-modal-content {
    width: 90vw;
    height: 90vh;
    display: grid;
    grid-template-rows: 40px 1fr;

    @supports (height: 100svh) {
      height: 90svh;
    }

    &--header {}
    
    &--body {
      width: 100%;
      height: 100%;
    }
  }
}
</style>